import { Component, OnInit, OnDestroy, ViewEncapsulation, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { AlertService } from '../_services';

export interface DialogData
{
	dialogMessage: string;
	details: string;
}

@Component({
    selector: 'app-alert',
    templateUrl: 'alert.component.html',
    styleUrls: ['./alert.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

/** alert service from https://stackoverflow.com/questions/44526390/angular-material-create-alert-similar-to-bootstrap-alerts */

export class AlertComponent implements OnInit, OnDestroy
{
	private subscription: Subscription;
	message: any;
	name = 'Message';
	actionButtonLabel = 'Retry';
	action = false;
	setAutoHide = true;
	autoHide = 5000;
	horizontalPosition: MatSnackBarHorizontalPosition = 'center';
	verticalPosition: MatSnackBarVerticalPosition = 'top';

	constructor(private alertService: AlertService, public dialog: MatDialog, public snackBar: MatSnackBar) { }

	ngOnInit()
	{
		this.subscription = this.alertService.getMessage().subscribe(message =>
		{
			this.message = message;
			if (this.message)
			{
				if (message.type === 'success')
				{
					// snackbar
					//  console.log('message: ' + JSON.stringify(this.message));
					this.openSnackBar(this.message.text.message || this.message.text);
				}
				if (message.type === 'error')
				{
					// alertBanner
					// console.log('ALERT COMPONENT!: ' + JSON.stringify(this.message));
					this.openDialog(this.message.text.message || this.message.text);
				}
			}
		});
	}

	ngOnDestroy()
	{
		this.subscription.unsubscribe();
	}

	openSnackBar(snackMessage)
	{
		let config = new MatSnackBarConfig();
		config.verticalPosition = this.verticalPosition;
		config.horizontalPosition = this.horizontalPosition;
		config.duration = this.setAutoHide ? this.autoHide : 0;
		this.snackBar.open(snackMessage, '', config);
	}
	openDialog(dialogMessage): void
	{
		const dialogRef = this.dialog.open(ErrorDialogComponent, {
			width: '600px',
			maxWidth: '90vw',
			data: { dialogMessage: dialogMessage, details: '' }
		});

		dialogRef.afterClosed().subscribe(result =>
		{
			console.log('The dialog was closed');
		});
	}
}


@Component({
    selector: 'app-error-dialog',
    templateUrl: 'alert-dialog.component.html',
    standalone: false
})
export class ErrorDialogComponent
{

	constructor(
		public dialogRef: MatDialogRef<ErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData) { }

	onNoClick(): void
	{
		this.dialogRef.close();
	}

}
